<template>
  <div :class="classes">
    <pt-page-title title="计算结果">
			<!-- +' （样本条码号：'+sampleInformation.sampleId+'）' -->
			<h3 slot="before-left" class="user" v-if="sampleInformation">{{sampleInformation.lastName+sampleInformation.firstName}}</h3>
		</pt-page-title>

    <wt-re-request-tip message="详情获取失败" :reLoad="load" v-show="loadFailed">
		</wt-re-request-tip>
    <el-input placeholder="输入检测项名称实时检索" icon="search" v-model="schfilter" class="search-input"></el-input>
		<el-button @click="close" v-text="switchText" type="primary"></el-button>
    <div class="bg detail" v-loading="loading">
			<!-- <wt-paged-table ref="table" :url="url" :url-method="urlMethod" :count-url="countUrl" :count-url-method="countUrlMethod" @page-loaded="onPageLoaded" :refresh="true"> -->
				<el-table :data='pageData' stripe style="width: 100%" height="100%" border ref="report-table" @row-dblclick="rowDbClick" @row-click="rowClick">
					<el-table-column prop="detectionItemNameCn" label="检测项名称" min-width="110">
						<template slot-scope="scope" >
							<template class="content-rowspan">
								<p>{{ scope.row.detectionItemNameCn }}</p>
							</template>
						</template>
					</el-table-column>
					<el-table-column prop="riskIndex" label="相对风险值" sortable min-width="130">
						<template slot-scope="scope" >
							<template class="content-rowspan">
								<p>{{ scope.row.riskIndex }}</p>
							</template>
						</template>
					</el-table-column>
					<!-- 药物类含有检测内容，如毒副作用 -->
					<el-table-column prop="" label="检测内容" min-width="100">
						<template slot-scope="scope" >
							<div class="content-rowspan rowspan" v-show="isSwitch">
								<p v-for="(value,index) in scope.row.locusInfo" :key="index">{{ value.detectionContent }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="相关位点名称/多态类型" class="special" min-width="120">
						<template slot-scope="scope" >
							<div class="content-rowspan rowspan" v-show="isSwitch">
								<p v-for="(value,index) in scope.row.locusInfo" :key="index">{{ value.name }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="位点风险值" min-width="120">
						<template slot-scope="scope">
							<div class="content-rowspan rowspan" v-show="isSwitch">
								<p v-for="(value,index) in scope.row.locusInfo" :key="index">{{ value.riskIndex }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="基因型" min-width="90">
						<template slot-scope="scope">
							<div class="content-rowspan rowspan" v-show="isSwitch">
								<p v-for="(value,index) in scope.row.locusInfo" :key="index">{{ value.geneType }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="基因" min-width="90">
						<template slot-scope="scope">
							<div class="content-rowspan rowspan" v-show="isSwitch">
								<p v-for="(value,index) in scope.row.locusInfo" :key="index">{{ value.gene }}</p>
							</div>
						</template>
					</el-table-column>
					<!-- CAUSAL -->
					<el-table-column prop="" label="致病基因" min-width="100">
						<template slot-scope="scope">
							<div class="content-rowspan rowspan" v-show="isSwitch">
								<p v-for="(value,index) in scope.row.causalGenes" :key="index">
									<template v-if="value.causalManualParamEntityDTO">
										{{ value.causalManualParamEntityDTO.causalGenes }}
									</template>
								</p>
							</div>
						</template>
					</el-table-column>
					<!-- CAUSAL -->
					<el-table-column prop="" label="突变位置" min-width="100">
						<template slot-scope="scope">
							<div class="content-rowspan rowspan" v-show="isSwitch" v-if="scope.row.causalGenes">
								<p v-for="(value,index) in scope.row.causalGenes" :key="index">
									<template v-if="value.causalManualParamEntityDTO">
									{{ value.causalManualParamEntityDTO.mutationPosition }}
									</template>
								</p>
							</div>
						</template>
					</el-table-column>
					<!-- CAUSAL -->
					<el-table-column prop="" label="突变类型" min-width="100">
						<template slot-scope="scope">
							<div class="content-rowspan rowspan" v-show="isSwitch" v-if="scope.row.causalGenes">
								<p v-for="(value,index) in scope.row.causalGenes" :key="index">
									<template v-if="value.causalManualParamEntityDTO">
									{{ value.causalManualParamEntityDTO.mutationType }}
									</template>
								</p>
							</div>
						</template>
					</el-table-column>
					<!-- CAUSAL -->
					<el-table-column prop="" label="致病性证据" min-width="130">
						<template slot-scope="scope">
							<div class="content-rowspan rowspan" v-show="isSwitch" v-if="scope.row.causalGenes">
								<p v-for="(value,index) in scope.row.causalGenes" :key="index">
									<template v-if="value.causalManualParamEntityDTO">
									{{ value.causalManualParamEntityDTO.mutationProof }}
									</template>
								</p>
							</div>
						</template>
					</el-table-column>
					<!-- CAUSAL -->
					<el-table-column prop="" label="人类频率" min-width="100">
						<template slot-scope="scope">
							<div class="content-rowspan rowspan" v-show="isSwitch" v-if="scope.row.causalGenes">
								<p v-for="(value,index) in scope.row.causalGenes" :key="index">
									<template v-if="value.causalManualParamEntityDTO">
									{{ value.causalManualParamEntityDTO.referFrequency }}
									</template>
								</p>
							</div>
						</template>
					</el-table-column>
					<!-- CAUSAL -->
					<el-table-column prop="" label="致病概述" min-width="130">
						<template slot-scope="scope">
							<div class="content-rowspan rowspan" v-show="isSwitch" v-if="scope.row.causalGenes">
								<p v-for="(value,index) in scope.row.causalGenes" :key="index">
									<template v-if="value.causalManualParamEntityDTO">
									{{ value.causalManualParamEntityDTO.reportSummary }}
									</template>
								</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="短建议" min-width="130">
						<template slot-scope="scope">
							<div class="content-rowspan rowspan" v-show="isSwitch">
								<p v-for="(value,index) in scope.row.locusInfo" :key="index">{{ value.shortConclusion }}</p>
							</div>
						</template>
					</el-table-column>
					<!-- 生活方式会有短建议和综合建议 -->
					<el-table-column prop="suggestion" label="综合建议" min-width="130">
						<template slot-scope="scope" >
							<template class="content-rowspan">
								<p>{{ scope.row.suggestion }}</p>
							</template>
						</template>
					</el-table-column>
				</el-table>
			<!-- </wt-paged-table> -->
		</div>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-show-calculate-result'

export default {
  name: 'pt-show-calculate-result',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      // 用于绑定的产品数据对象
      report: this.$route.params.value ? this.$route.params.value : null,
      // 页面是否在进行数据loading
      loading: false,
      // 是否加载失败，用于显示遮罩层，用户可触发重试
      loadFailed: false,
      pageData: [],
      oldData: [],
      schfilter: '',
      isSwitch: false,
      switchText: '全部展开',
      sampleInformation: {}
    }
  },
  watch: {
    schfilter: function (val, oldVal) {
      this.pageData = this.oldData.filter(item => (~item.detectionItemNameCn.indexOf(val)))
    }
  },
  methods: {
    // 加载详情数据
    load () {
      this.loading = true
      this.loadFailed = false
      // console.log('data-------',data)
      let data = {}
      data.jobId = this.jobId
      this.$store.dispatch('getReportData', data).then((response) => {
        this.loadFailed = false
        this.loading = false
        console.log('response', response.data)
        this.sampleInformation = response.data.sampleInformation
        if (response.data.message) {
          this.$message.error(response.data.message)
        } else {
          this.resport = response.data.analysisResultsList
          var arr = []
          for (var i in this.resport) {
            this.resport[i].forEach(item => {
              arr.push(item)
            })
          }
          this.pageData = arr
          this.oldData = arr
          console.log('arr', arr)
          console.log('this.pageData', this.pageData)
        }
      }).catch((error) => {
        this.loading = false
        this.loadFailed = true
        this.$message.error(error)
      })
    },
    close () {
      this.isSwitch = !this.isSwitch
      if (this.isSwitch) {
        this.switchText = '全部收起'
      } else {
        this.switchText = '全部展开'
      }
    },
    // 双击这行展开内容
    rowDbClick (row, event) {
      var targetRow = this.searchTargetNode(event)
      var targetNode = ''
      if (targetRow !== '') {
        targetNode = targetRow.querySelectorAll('.rowspan')
        targetNode.forEach(element => {
          element.style.display = 'block'
        })
      }
    },
    // 一直找类名为el-table__row的节点，目前html结构的最大深度为4级
    searchTargetNode (event) {
      var targetRow = ''
      if (event.target.parentElement.className.indexOf('el-table__row') > -1) {
        targetRow = event.target.parentElement
      } else {
        if (event.target.parentElement.parentElement.className.indexOf('el-table__row') > -1) {
          targetRow = event.target.parentElement.parentElement
        } else {
          if (event.target.parentElement.parentElement.parentElement.className.indexOf('el-table__row') > -1) {
            targetRow = event.target.parentElement.parentElement.parentElement
          } else {
            if (event.target.parentElement.parentElement.parentElement.parentElement.className.indexOf('el-table__row') > -1) {
              targetRow = event.target.parentElement.parentElement.parentElement.parentElement
            }
          }
        }
      }
      return targetRow
    },
    // 单击收起
    rowClick (row, event, column) {
      // 单击本行才可收起
      var targetRow = this.searchTargetNode(event)
      var targetNode = ''
      if (targetRow !== '') {
        targetNode = targetRow.querySelectorAll('.rowspan')
        targetNode.forEach(element => {
          element.style.display = 'none'
        })
      }
      // 单击任意一行都可收起
      // var targetNode = document.querySelectorAll('.rowspan')
      // targetNode.forEach(element => {
      // 	element.style.display = 'none'
      // });
    }
  },
  created () {
    // 如果父组件没有传入产品数据，则本页面根据id进行获取
    this.jobId = this.$route.params.jobId
    if (!this.report) {
      this.load()
    }
  }
}
</script>

<style lang="less">
.pt-show-calculate-result{
	// display: flex;
	// display: -webkit-flex;
	// display:-ms-flexbox;
	// flex-direction:column;
	// -webkit-flex-direction:column;
	// -webkit-box-orient:vertical;
	// -ms-flex-direction:column;
	height: 100%;
	.bg{
		// flex:1;
		// -webkit-box-flex:1;
		// -webkit-flex:1;
		// -ms-flex:1;
		.el-table{
			overflow:auto;
      height: 100%;
      min-height: 700px;
		}

	}
	.content-rowspan{
		p{
			line-height:18px;
		}
	}
	.el-table td{
		vertical-align: top;
	}
	.search-input.el-input{
		margin-right: 20px;
		width:300px;
		margin-bottom: 20px;
  }
  .el-button{
    max-width: 100px;
    margin-bottom: 20px;
  }
	.title{
		padding: 2rem 0 0rem;
	}
	h3.user{
		font-size: 20px;
	}
}

</style>
